<table mat-table class="mat-table-selection" [dataSource]="dataSource">

    <ng-container matColumnDef="noRecord">
        <td class="no-record" [colSpan]="this.columnsToDisplay.length" mat-footer-cell *matFooterCellDef>
            {{'no data available' | translate: ['shared.tmc-table.nodata', translationService.language]}}
        </td>
    </ng-container>

    <ng-container matColumnDef="hint">
        <th mat-header-cell *matHeaderCellDef>
            {{'hint'| translate:['tmc-yard.entity.transport.hint', translationService.language]}}</th>
        <td mat-cell *matCellDef="let transport" [ngClass]="{'selected': selectedId === transport.id}">
            <sc-flex>

                <app-transport-scope-icon [scope]="transport.transportScope" [type]="transport.transportType">
                </app-transport-scope-icon>

                <ng-container *ngIf="transport.useGlobalConnect">
                    <sc-content-spacer [half]="true"></sc-content-spacer>
                    <sc-icon iconClass="fa-qrcode"></sc-icon>
                </ng-container>

                <ng-container *ngIf="transport.useSms">
                    <sc-content-spacer [half]="true"></sc-content-spacer>
                    <sc-icon iconClass="fa-message-sms"></sc-icon>
                </ng-container>

                <ng-container *ngIf="transport.usePager">
                    <sc-content-spacer [half]="true"></sc-content-spacer>
                    <sc-icon iconClass="fa-wifi"></sc-icon>
                </ng-container>

                <ng-container *ngIf="transport.important">
                    <sc-content-spacer [half]="true"></sc-content-spacer>
                    <sc-icon iconClass="fa-exclamation"></sc-icon>
                </ng-container>

                <ng-container *ngIf="transport.urgent">
                    <sc-content-spacer [half]="true"></sc-content-spacer>
                    <sc-icon iconClass="fa-truck-fast"></sc-icon>
                </ng-container>

                <ng-container *ngIf="transport.intermitted">
                    <sc-content-spacer [half]="true"></sc-content-spacer>
                    <sc-icon iconClass="fa-octagon-xmark"></sc-icon>
                </ng-container>

                <ng-container *ngIf="transport.umbrueckung">
                    <sc-content-spacer [half]="true"></sc-content-spacer>
                    <sc-icon iconClass="fa-shuffle"></sc-icon>
                </ng-container>

                <ng-container *ngIf="transport.dangerousGoods">
                    <sc-content-spacer [half]="true"></sc-content-spacer>
                    <sc-icon iconClass="fa-skull-crossbones"></sc-icon>
                </ng-container>

                <ng-container *ngIf="transport.pendingTaskState !== PendingTaskState.NONE">
                    <sc-content-spacer [half]="true"></sc-content-spacer>
                    <app-task-state-icon [state]="transport.pendingTaskState"></app-task-state-icon>
                </ng-container>

            </sc-flex>
        </td>
    </ng-container>

    <ng-container matColumnDef="carrier">
        <th mat-header-cell *matHeaderCellDef>
            {{'carrier'| translate:['tmc-yard.entity.transport.carrier', translationService.language]}}</th>
        <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedId == transport.id}"> {{transport.carrier}} </td>
    </ng-container>

    <ng-container matColumnDef="supplier">
        <th mat-header-cell *matHeaderCellDef>
            {{'supplier'| translate:['tmc-yard.entity.transport.supplier', translationService.language]}}
        </th>
        <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedId == transport.id}"> {{transport.supplier}} </td>
    </ng-container>

    <ng-container matColumnDef="identifier">
        <th mat-header-cell *matHeaderCellDef>
            {{'numberplate'| translate:['tmc-yard.entity.transport.numberplate',
            translationService.language]}}
        </th>
        <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedId == transport.id}"> {{transport.identifier}} </td>
    </ng-container>

    <ng-container matColumnDef="driver">
        <th mat-header-cell *matHeaderCellDef>
            {{'driver'| translate:['tmc-yard.entity.transport.driver', translationService.language]}}</th>
        <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedId == transport.id}"> {{transport.driver}} </td>
    </ng-container>

    <ng-container matColumnDef="visitStatusDict">
        <th mat-header-cell *matHeaderCellDef>
            {{'status'| translate:['tmc-yard.entity.transport.status', translationService.language]}}</th>
        <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedId == transport.id}">
            {{transport.status | translate: ['tmc.transport-status.' + transport.status,
            translationService.language]}}
        </td>
    </ng-container>

    <ng-container matColumnDef="string1">
        <th mat-header-cell *matHeaderCellDef>
            {{'string1'| translate:['tmc-yard.entity.transport.string-1', translationService.language]}}
        </th>
        <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedId == transport.id}"> {{transport.string1}} </td>
    </ng-container>

    <ng-container matColumnDef="string2">
        <th mat-header-cell *matHeaderCellDef>
            {{'string2'| translate:['tmc-yard.entity.transport.string-2', translationService.language]}}
        </th>
        <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedId == transport.id}"> {{transport.string2}} </td>
    </ng-container>

    <ng-container matColumnDef="start">
        <th mat-header-cell *matHeaderCellDef>
            {{'start'| translate:['tmc-yard.entity.transport.start', translationService.language]}}</th>
        <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedId == transport.id}"> {{transport.start}} </td>
    </ng-container>

    <ng-container matColumnDef="reference">
        <th mat-header-cell *matHeaderCellDef>
            {{'reference'| translate:['tmc-yard.entity.transport.reference', translationService.language]}}
        </th>
        <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedId == transport.id}"> {{transport.reference}} </td>
    </ng-container>

    <ng-container matColumnDef="options">
        <th mat-header-cell *matHeaderCellDef>
            {{'options'| translate:['tmc-yard.entity.transport.options', translationService.language]}}</th>
        <td mat-cell class="multiple-lines text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedId == transport.id}">
            {{transport.options}}
        </td>
    </ng-container>

    <ng-container matColumnDef="cargo">
        <th mat-header-cell *matHeaderCellDef>
            {{'cargo'| translate:['tmc-yard.entity.transport.cargo', translationService.language]}}</th>
        <td mat-cell class="multiple-lines text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedId == transport.id}"> {{transport.cargo}}
        </td>
    </ng-container>

    <ng-container matColumnDef="planningDate">
        <th mat-header-cell *matHeaderCellDef>
            {{'planningDate'| translate:['tmc-yard.entity.transport.planning-date',
            translationService.language]}}
        </th>
        <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedId == transport.id}"> {{transport.planningDate}} </td>
    </ng-container>

    <ng-container matColumnDef="messagingResources">
        <th mat-header-cell *matHeaderCellDef>
            {{'messagingResources'| translate:['tmc-yard.entity.transport.messaging-resources',
            translationService.language]}}
        </th>
        <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedId == transport.id}"> {{transport.messagingResources}}
        </td>
    </ng-container>

    <ng-container matColumnDef="filler">
        <th mat-header-cell *matHeaderCellDef style="width: 100%;"> &nbsp; </th>
        <td mat-cell *matCellDef="let transport" [ngClass]="{'selected' : transport.id === selectedId}"> &nbsp;</td>
      </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

    <tr mat-row *matRowDef="let transport; columns: columnsToDisplay" [attr.data-transport-id]="transport.id"
        ></tr>

    <tr [class.hide]="dataSource.data.length > 0" mat-footer-row *matFooterRowDef="['noRecord']"></tr>
</table>